import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { Box, Typography, Divider } from '@mui/material';
import { usersPathTo } from '../utils/Api';
import { UserContext } from '../contexts/UserContext';
import SnackbarContext from '../contexts/SnackbarContext';
import { useNavigate } from 'react-router-dom';

const GoogleAuthButton = ({ onSuccessNavigateTo = '/home' }) => {
  const { setCurrentUser } = React.useContext(UserContext);
  const { openSnackbar } = React.useContext(SnackbarContext);
  const navigate = useNavigate();

  const handleSuccess = (response) => {
    if (!response?.credential) {
      openSnackbar('Não foi possível autenticar com o Google.', 'error');
      return;
    }

    usersPathTo.googleAuth({ credential: response.credential }).then(
      (result) => {
        setCurrentUser(result.data);
        localStorage.setItem('current_user', JSON.stringify(result.data));
        openSnackbar('Login realizado com sucesso!', 'success');
        navigate(onSuccessNavigateTo);
      },
      (error) => {
        const message =
          error?.response?.data?.error ||
          'Erro ao autenticar com o Google. Tente novamente.';
        openSnackbar(message, 'error');
      }
    );
  };

  const handleError = () => {
    openSnackbar('Falha ao conectar com o Google.', 'error');
  };

  if (!process.env.REACT_APP_GOOGLE_CLIENT_ID) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, alignSelf: 'stretch', width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, alignSelf: 'stretch', width: '100%' }}>
        <Divider sx={{ flex: 1 }} />
        <Typography sx={{ color: 'text.secondary', fontSize: '12px', fontWeight: 600 }}>
          ou
        </Typography>
        <Divider sx={{ flex: 1 }} />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <GoogleLogin
          onSuccess={handleSuccess}
          onError={handleError}
          useOneTap={false}
          theme="outline"
          size="large"
          text="continue_with"
          shape="pill"
          width="320"
        />
      </Box>
    </Box>
  );
};

export default GoogleAuthButton;
